<template>
  <div class="c-performance" :class="[type]">
    <div class="c-performance__label">{{ label }}</div>
    <div class="c-performance__bar" :style="style" />
  </div>
</template>

<script>
export default {
  name: 'c-performance',
  props: {
    value: {
      type: Number,
      required: true
    },
    valueFormatted: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },
  computed: {
    type() {
      if (this.value > 0) {
        return 'positive';
      } else if (this.value < 0) {
        return 'negative';
      } else {
        return 'neutral';
      }
    },
    label() {
      if (this.value > 0) {
        return `+${this.valueFormatted}%`;
      } else if (this.value < 0) {
        return `${this.valueFormatted}%`;
      } else {
        return `±0.00%`;
      }
    },
    style() {
      if (this.type === 'negative') {
        return {
          width: `${(this.value * 100) / this.min}%`,
          'margin-left': 'auto'
        };
      } else {
        return {
          width: `${(this.value * 100) / this.max}%`,
          'margin-right': 'auto'
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-performance';
</style>
